<template>
  <div class="saticibilgi">

      <v-text-field hide-details label="Satıcı Tipi" v-model="saticiBilgi.SaticiTipi"></v-text-field>

      <v-text-field hide-details label="Satıcı Kodu" v-model="saticiBilgi.Kod"  required  v-on:change="$emit('kodonchange');" > </v-text-field>
      <v-text-field hide-details label="Satıcı Adı" v-model="saticiBilgi.Isim"  required>  </v-text-field>
      <cariara v-model="saticiBilgi.Cari_Kod" ></cariara>
      <v-text-field hide-details label="Email" v-model="saticiBilgi.Email"></v-text-field>
      <v-text-field hide-details label="Telefon" v-model="saticiBilgi.Tel1"></v-text-field>
      <v-text-field hide-details label="Adres" v-model="saticiBilgi.Adres"></v-text-field>

  </div>
</template>

<script>

   import cariara from   '@/components/app/coper/comp/cariara.vue';


export default {
  props: ['value'],
  
  computed: {
    saticiBilgi() {
       return this.value;
    }
  },
  components: {
      cariara,
    },

  methods: {
    updateDate() {
      //const monthValue = this.$refs.monthPicker.value;
      //const yearValue = this.$refs.yearPicker.value;
      //this.$emit('input', `${monthValue}/${yearValue}`);
    },
    
  }
};
</script>